import { useMutation, useQueryClient } from 'react-query';
import { httpClient } from 'src/utils/HttpClients';
import type { TPostBookingPayload } from 'src/types/booking';
import get from 'lodash/get';
import type { TSubLocation } from 'src/types';
import { DATE_FORMAT } from 'src/constants';
import { useAppState } from 'src/context';

export const useUpdateBooking = () => {
    const queryClient = useQueryClient();
    const {
        values: { range, location },
    } = useAppState();
    // Getting sub locations list
    const sdata = queryClient.getQueryData(['sub-locations', location]);
    const params = {
        sublocation_ids: get(sdata, 'data', []).map((subLocation: TSubLocation) => subLocation.id),
        start_date: range.from.toFormat(DATE_FORMAT),
        end_date: range.to.toFormat(DATE_FORMAT),
    };

    const mutationFn = async (payload: TPostBookingPayload) => {
        const { id, ...rest } = payload;
        const { data } = await httpClient.put(`/booking/${id}`, rest);
        return data;
    };

    const onSuccess = async () => {
        await Promise.all([
            queryClient.invalidateQueries(['bookings', params]),
            queryClient.invalidateQueries(['policy-compliance'], { exact: false }),
        ]);
    };

    return useMutation(mutationFn, { onSuccess });
};
